<script setup lang="ts">
import AppMasthead from '@/components/AppMasthead.vue'
import ImpersonationBanner from '@/components/ImpersonationBanner.vue'
import AppSubnav from '@/components/AppSubnav.vue'
import AppFooter from '@/components/AppFooter.vue'
import AdminNav from '@/components/AdminNav.vue'
import '@/styles/admin.css'

// Admin chrome (M4c part 2): the same Broadsheet sheet with the dark "ADMIN DESK" strip, now with
// the grouped AdminNav sidebar (Events / People / Commerce / Content / Tools) beside the page.
</script>

<template>
  <div class="bs-page">
    <ImpersonationBanner />
    <AppMasthead />
    <AppSubnav />
    <div class="bs-strip admin-strip" role="note">
      <span>Admin desk</span>
      <span><RouterLink to="/admin">Dashboard</RouterLink></span>
      <span><RouterLink to="/">Back to the front page</RouterLink></span>
    </div>
    <main class="bs-main">
      <div class="adm-shell">
        <AdminNav />
        <div class="adm-page">
          <slot />
        </div>
      </div>
    </main>
    <AppFooter />
  </div>
</template>

<style scoped>
.admin-strip a {
  color: var(--strip-fg, #dbe7f2);
  text-decoration: none;
}
.admin-strip a:hover {
  color: #fff;
  text-decoration: underline;
}
.adm-page {
  min-width: 0;
}
</style>
